export const RELOAD_KEY = 'vite-preload-error-reloaded-at';

export const RELOAD_COOLDOWN_MS = 30_000;

export const isChunkLoadError = (error) => {
  const message = error?.message;
  if (typeof message !== 'string') return false;

  return message.includes('dynamically imported module') || message.includes('Importing a module script failed');
};

const getLastReloadedAt = () => {
  const lastReloadedAt = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0);

  return Number.isFinite(lastReloadedAt) ? lastReloadedAt : 0;
};

export const canReloadAfterChunkError = () => {
  const lastReloadedAt = getLastReloadedAt();

  return Date.now() - lastReloadedAt > RELOAD_COOLDOWN_MS;
};

export const markChunkErrorReload = () => {
  sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
};

export const triggerChunkReload = () => {
  markChunkErrorReload();
  window.location.reload();
};

export const registerChunkErrorListener = () => {
  const handler = (event) => {
    if (canReloadAfterChunkError()) {
      event.preventDefault();
      triggerChunkReload();
    }
  };
  window.addEventListener('vite:preloadError', handler);
  return () => window.removeEventListener('vite:preloadError', handler);
};
